import { useState, useRef, useEffect } from "react";
import styles from "./Dropdown.module.css";

const Dropdown = ({ options, value, onChange, placeholder = "Select..." }) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleSelect = (option) => {
		onChange(option);
		setIsOpen(false);
	};

	const selectedOption = options.find((option) => option.value === value);

	return (
		<div className={styles.dropdown} ref={dropdownRef}>
			<button className={styles.dropdownButton} onClick={() => setIsOpen(!isOpen)} type="button">
				<span className={styles.dropdownText}>{selectedOption ? selectedOption.label : placeholder}</span>
				<svg
					className={`${styles.dropdownIcon} ${isOpen ? styles.dropdownIconOpen : ""}`}
					width="12"
					height="12"
					viewBox="0 0 12 12"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</button>

			{isOpen && (
				<div className={styles.dropdownMenu}>
					{options.map((option) => (
						<button
							key={option.value}
							className={`${styles.dropdownItem} ${option.value === value ? styles.dropdownItemSelected : ""}`}
							onClick={() => handleSelect(option)}
							type="button"
						>
							{option.label}
						</button>
					))}
				</div>
			)}
		</div>
	);
};

export default Dropdown;
